import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import "./ClientmanagentDigitalMenu.css";


const getDefaultClientDetailsRows = () => [
    { key: "Owner Name", value: "", isUpload: false },
    { key: "Business Plan", value: "", isUpload: false },
    { key: "LOGO", value: null, isUpload: false },
    { key: "Register Name", value: "", isUpload: false },
    { key: "Register Documents", value: "", isUpload: true },
    { key: "Phone No", value: "", isUpload: false },
    { key: "Email ID", value: "", isUpload: false },
    {
        key: "Bank Details",
        value: {
            accountHolderName: "",
            bankName: "",
            accountNo: "",
            ifscCode: "",
        },
        isUpload: false,
    },
    { key: "AADHAR CARD NO", value: "", isUpload: false },
    { key: "PAN CARD NO", value: "", isUpload: false },
    { key: "Website", value: "", isUpload: false },
    { key: "GST No.", value: "", isUpload: false },
];


const STATUS_FIELD_MAP = {
    "Business Plan": "businessPlanStatus",
    "Company Name": "registeredNameStatus",
    "Register Documents": "registeredDocumentsStatus",
    "Owner Name": "ownerNameStatus",
    "Business Vertical": "businessPlanStatus",
    "Type": "typeStatus",
    "Phone No": "mobileNumberStatus",
    "Email ID": "emailStatus",
    "AADHAR CARD NO": "aadharNumberStatus",
    "PAN CARD NO": "panCardStatus",
    "Website": "websiteNameStatus",
    "GST No.": "gstNumberStatus",
    "Trade License": "tradeLicenseStatus",
    "FSSI License": "fssaiLicenseStatus",
    "Labour License": "labourLicenseStatus",
};

/* ---------------- component ---------------- */
const Logisticspaidclients = () => {
    /* -------- list‑screen state -------- */
    const [rolesData, setRolesData] = useState([]);
    const [statusFilter, setStatusFilter] = useState("");
    const [verticalFilter, setVerticalFilter] = useState("");
    const [planFilter, setPlanFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    /* -------- detail‑screen state -------- */
    const [selectedClient, setSelectedClient] = useState(null);
    const [vendorDetails, setVendorDetails] = useState(null);
    const [loading, setLoading] = useState(false);

    const [rows, setRows] = useState(getDefaultClientDetailsRows());
    const [verifiedRows, setVerifiedRows] = useState([]);
    const [rejectedRows, setRejectedRows] = useState([]);
    const [isApproved, setIsApproved] = useState(false);

    const fileInputRef = useRef(null);

    /* ---------------- fetch list on mount ---------------- */
    useEffect(() => {
        fetch(
            "https://backend.maamaas.com/subscription/api/admin/get-all"
        )
            .then((res) => res.json())
            .then((data) => setRolesData(data))
            .catch((err) => console.error("list fetch error:", err));
    }, []);

    /* ---------------- filter whenever controls change ---------------- */
    useEffect(() => {
        let data = rolesData;
        if (statusFilter) data = data.filter((i) => i.status === statusFilter);
        if (verticalFilter) data = data.filter((i) => i.businessVertical === verticalFilter);
        if (planFilter) data = data.filter((i) => i.businessPlan === planFilter);
        setFilteredData(data);
    }, [statusFilter, verticalFilter, planFilter, rolesData]);

    /* ---------------- fetch vendor‑level details ---------------- */
    const fetchVendorDetails = async (vendorId) => {
        if (!vendorId) return;
        setLoading(true);
        try {
            const res = await fetch(
                `https://backend.maamaas.com/subscription/api/vendors/${vendorId}`
            );
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            setVendorDetails(data);
        } catch (err) {
            console.error("get‑vendor‑details error:", err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- build rows whenever selection or vendorDetails changes ---------------- */
    useEffect(() => {
        if (!selectedClient) {
            setRows(getDefaultClientDetailsRows());
            setVerifiedRows([]);
            setRejectedRows([]);
            setIsApproved(false);
            return;
        }

        // merge selectedClient (subscription object) + vendorDetails into one flat object
        const merged = { ...selectedClient, ...(vendorDetails || {}) };

        const newRows = [
            { key: "Owner Name", value: merged.ownerName || "N/A" },
            { key: "Company Name", value: merged.registeredName || "N/A" },
            { key: "Business Plan", value: merged.businessPlan || "N/A" },
            { key: "Type", value: merged.type || "N/A" },
            { key: "Business Vertical", value: merged.businessVertical || "N/A" },
            { key: "Order Type", value: Array.isArray(merged.orderTypes) ? merged.orderTypes.join(", ") : merged.orderTypes || "N/A" },
            { key: "Register Documents", value: merged.registeredName || "N/A" },
            { key: "Website", value: merged.websiteName || "N/A" },
            { key: "Phone No", value: merged.mobileNumber || "N/A" },
            { key: "Email ID", value: merged.email || "N/A" },
            {
                key: "Address",
                value: {
                    doorNo: merged.doorNumber || "N/A",
                    street: merged.addressLine || "N/A",
                    city: merged.city || "N/A",
                    state: merged.state || "N/A",
                    pincode: merged.pincode || "N/A",
                    landmark: merged.landMark || "N/A",
                },
            },
            { key: "AADHAR CARD NO", value: merged.aadharNumber || "N/A" },
            { key: "PAN CARD NO", value: merged.panCardNumber || "N/A" },
            {
                key: "Trade License",
                value: {
                    startDate: merged.tradeLicenseStartDate || "N/A",
                    endDate: merged.tradeLicenseEndDate || "N/A",
                },
            },
            {
                key: "FSSI License",
                value: {
                    startDate: merged.fssaiStartDate || "N/A",
                    endDate: merged.fssaiEndDate || "N/A",
                },
            },
            {
                key: "Labour License",
                value: {
                    startDate: merged.labourStartDate || "N/A",
                    endDate: merged.labourEndDate || "N/A",
                },
            },
            { key: "GST No.", value: merged.gstNumber || "N/A" },
            {
                key: "Bank Details",
                value: {
                    accountHolderName: merged.holderName || "N/A",
                    bankName: merged.branchName || "N/A",
                    accountNo: merged.accountNumber || "N/A",
                    ifscCode: merged.ifscCode || "N/A",
                },
            },
        ].map((r) => ({ ...r, isEditing: false }));


        // pre‑populate verifiedRows based on backend status flags
        const preVerified = [];
        newRows.forEach((r, idx) => {
            const statusField = STATUS_FIELD_MAP[r.key];
            if (statusField && merged[statusField]) preVerified.push(idx);
        });

        setRows(newRows);
        setVerifiedRows(preVerified);
        setRejectedRows([]);
        setIsApproved(false);
    }, [selectedClient, vendorDetails]);

    /* ---------------- helper: get vendorId from current selection ---------------- */
    const getCurrentVendorId = () => {
        return (
            selectedClient?.vendorId ||
            selectedClient?.vendorEnquiry?.vendorId ||
            vendorDetails?.vendorId ||
            null
        );
    };

    /* ---------------- list‑row click ---------------- */
    const handleViewClick = (client) => {
        setSelectedClient(client);
        const vendorId =
            client?.vendorEnquiry?.vendorId || client.vendorId || client.vendorID;
        fetchVendorDetails(vendorId);
    };

    /* ---------------- verify / reject handlers ---------------- */
    const handleReject = (i) =>
        setRejectedRows((prev) => (prev.includes(i) ? prev : [...prev, i]));

    // --- improved version ---
    const handleVerifyy = async (i) => {
        // 1️⃣  Derive the backend field name
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) {
            // No mapping → just mark locally
            setVerifiedRows((prev) => (prev.includes(i) ? prev : [...prev, i]));
            return;
        }

        // 2️⃣  Build request
        const vendorId = getCurrentVendorId();
        if (!vendorId) {
            alert("Vendor ID is missing – cannot update.");
            return;
        }

        const url = `https://backend.maamaas.com/subscription/api/vendors/edit/${vendorId}`;
        const payload = { [statusField]: true };
        const token = localStorage.getItem("authToken");

        // console.log("PATCH →", url, payload);

        try {
            const res = await fetch(url, {
                method: "PUT",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            // 3️⃣  Handle response
            if (!res.ok) {
                let msg = "";
                try { msg = (await res.json()).message || ""; }
                catch { msg = await res.text(); }
                throw new Error(msg || `HTTP ${res.status}`);
            }

            // 4️⃣  Success – update UI
            setVerifiedRows((prev) => (prev.includes(i) ? prev : [...prev, i]));
            setVendorDetails((prev) => ({ ...(prev || {}), [statusField]: true }));
        } catch (err) {
            console.error("status‑update error:", err);
            alert(`Failed to update status: ${err.message}`);

            if (/Failed to fetch|NetworkError/i.test(err.message)) {
                alert("CORS error: Backend must allow requests from http://localhost:3000");
            }
        }
    };

    const handleApprove = async () => {
        if (!selectedClient?.id) {
            alert("No payment ID found for approval");
            return;
        }

        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(
                `https://backend.maamaas.com/subscription/api/payments/update/${selectedClient.id}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        approval: "APPROVED",
                        // You might need to include other required fields based on your API
                        // For example:
                        // vendorId: selectedClient.vendorId,
                        // planType: selectedClient.planType,
                    })
                }
            );

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to update approval status');
            }

            const data = await response.json();
            // console.log('Approval updated:', data);

            // Update the local state to reflect the change
            setIsApproved(true);
            setSelectedClient(prev => ({ ...prev, status: "APPROVED" }));

            // Optionally refresh the list data
            const listRes = await fetch(
                "https://backend.maamaas.com/subscription/api/admin/get-all"
            );
            const updatedList = await listRes.json();
            setRolesData(updatedList);

            alert('Payment approved successfully!');
        } catch (error) {
            console.error('Error updating approval:', error);
            alert(`Failed to approve payment: ${error.message}`);
        }
    };



    /* ---------------- misc handlers ---------------- */
    const handleBackClick = () => setSelectedClient(null);


    const handleFileChange = (e, index) => {
        const fileName = e.target.files[0]?.name || "";
        const updated = [...rows];
        updated[index].value = fileName;
        setRows(updated);
    };
    const handleUploadClick = () => fileInputRef.current?.click();

    /* ---------------- CSV export ---------------- */
    const handleExport = () => {
        const escapeCsv = (field) => {
            const str = String(field ?? "");
            return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
        };

        const headers = [
            "S.NO",
            "Vendor Name",
            "Email",
            "Mobile",
            "City",
            "Vertical",
            "Plan",
            "VendorId",
            "Password",
            "StartDate",
            "EndDate",
            "Status",
        ];

        const rowsCsv = filteredData.map((c, i) => [
            i + 1,
            c?.vendorEnquiry?.name,
            c?.vendorEnquiry?.email,
            c?.vendorEnquiry?.mobileNumber,
            c?.vendorEnquiry?.city,
            c?.vendorEnquiry?.businessVertical,
            c?.subscriptionPlan?.planType,
            c?.vendorId,
            c.password,
            c.tradeLicenseStartDate || "-",
            c.tradeLicenseEndDate || "-",
            c.status || "-",
        ]);

        const csvString = [
            headers.map(escapeCsv).join(","),
            ...rowsCsv.map((r) => r.map(escapeCsv).join(",")),
        ].join("\r\n");

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "clients.csv";
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
    };

    /* ---------------- render ---------------- */
    const registerDocIndex = rows.findIndex((r) => r.key === "Register Documents");



    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">

                    <div
                        className="client"
                        style={{ overflowY: "auto", height: "500px", marginTop: 20 }}
                    >
                        {/* ------------------- LIST SCREEN ------------------- */}
                        {!selectedClient ? (
                            <>
                                {/* filters */}
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div>


                                    </div>
                                    <div className="pe-3">

                                    </div>
                                </div>

                                {/* table */}
                                <div className="sed pe-3">
                                    <table style={tableStyle} className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={thStyle}>S.NO</th>
                                                <th style={thStyle}>Name</th>
                                                <th style={thStyle}>Email</th>
                                                <th style={thStyle}>Mobile</th>
                                                <th style={thStyle}>City</th>
                                                <th style={thStyle}>Vertical</th>

                                                <th style={thStyle}>Plan</th>
                                                <th style={thStyle}>Vendor Id</th>
                                                <th style={thStyle}>Payment Id</th>

                                                <th style={thStyle}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.length ? (
                                                filteredData.map((c, idx) => (
                                                    <tr key={c.vendorId || idx}>
                                                        <td style={thTdStyle}>{idx + 1}</td>
                                                        <td style={thTdStyle}>{c?.vendorName || "—"}</td>
                                                        <td style={thTdStyle}>{c?.email || "—"}</td>
                                                        <td style={thTdStyle}>
                                                            {c?.mobileNumber || "—"}
                                                        </td>
                                                        <td style={thTdStyle}>{c?.city || "—"}</td>
                                                        <td style={thTdStyle}>
                                                            {c?.businessVertical || "—"}
                                                        </td>

                                                        <td style={thTdStyle}>
                                                            {c?.planType || "—"}
                                                        </td>
                                                        <td style={thTdStyle}>{c?.vendorId || "—"}</td>
                                                        <td style={thTdStyle}>{c?.id || "—"}</td>

                                                        <td style={thTdStyle}>
                                                            <button
                                                                style={{ ...buttonStyle, color: "#b15cd6", fontWeight: "bold" }}
                                                                onClick={() => handleViewClick(c)}
                                                            >
                                                                View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td style={thTdStyle} colSpan={13}>
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        ) : (
                            /* ------------------- DETAIL SCREEN ------------------- */
                            <div className="mt-4 rounded-3 shadow-sm">
                                {/* header with back button */}
                                <div className="d-flex align-items-center mb-4">
                                    <button
                                        onClick={handleBackClick}
                                        className="btn fw-bold px-4 py-2"
                                        style={{ backgroundColor: "#b15cd6", color: "#fff" }}
                                    >
                                        Back to List
                                    </button>

                                </div>

                                {loading && (
                                    <div className="text-center my-4">
                                        <span className="spinner-border text-primary" />
                                    </div>
                                )}


                                {!loading && (
                                    <div className="register mt-4">
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            className="d-none"
                                            onChange={(e) =>
                                                registerDocIndex !== -1 && handleFileChange(e, registerDocIndex)
                                            }
                                        />
                                        <div className="registertable bo2">
                                            <table className="table table-bordered table-striped align-middle mt-4 w-100">
                                                <thead>
                                                    <tr>
                                                        <th style={detailThStyle}>Field</th>
                                                        <th style={detailThStyle}>Value</th>
                                                        <th style={detailThStyle}>Status</th>
                                                        {/* <th style={detailThStyle}>Remarks</th> */}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {rows.map((r, i) => (
                                                        <tr key={r.key || i}>
                                                            <td className="fw-bold text-center">{r.key}</td>
                                                            <td className="text-center">
                                                                {r.key === "Bank Details" ? (
                                                                    <div className="text-start">
                                                                        <div>Account Holder: {r.value.accountHolderName}</div>
                                                                        <div>Bank Name: {r.value.bankName}</div>
                                                                        <div>Account No: {r.value.accountNo}</div>
                                                                        <div>IFSC Code: {r.value.ifscCode}</div>
                                                                    </div>
                                                                ) : r.key === "Address" ? (
                                                                    <div className="text-start">
                                                                        <div>Door No: {r.value.doorNo}</div>
                                                                        <div>Street: {r.value.street}</div>
                                                                        <div>City: {r.value.city}</div>
                                                                        <div>State: {r.value.state}</div>
                                                                        <div>Pincode: {r.value.pincode}</div>
                                                                        <div>Landmark: {r.value.landmark}</div>
                                                                    </div>
                                                                ) : r.key === "Trade License" ? (
                                                                    <div className="text-start">
                                                                        <div>Start Date: {r.value.startDate}</div>
                                                                        <div>End Date: {r.value.endDate}</div>
                                                                    </div>
                                                                ) : r.key === "FSSI License" ? (
                                                                    <div className="text-start">
                                                                        <div>Start Date: {r.value.startDate}</div>
                                                                        <div>End Date: {r.value.endDate}</div>
                                                                    </div>
                                                                ) : r.key === "Labour License" ? (
                                                                    <div className="text-start">
                                                                        <div>Start Date: {r.value.startDate}</div>
                                                                        <div>End Date: {r.value.endDate}</div>
                                                                    </div>
                                                                ) : r.isUpload ? (
                                                                    <div className="d-flex justify-content-between align-items-center px-2">
                                                                        <span>{r.value || "No file selected"}</span>
                                                                        <button className="btn btn-link p-0" onClick={handleUploadClick}>
                                                                            {r.value ? "Change File" : "Upload File"}
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    r.value
                                                                )}
                                                            </td>

                                                            {/* Verify/Reject Buttons */}
                                                            <td className="text-center">
                                                                <button
                                                                    className={`btn btn-sm ${verifiedRows.includes(i) ? "btn-success" : "btn-warning"} me-2`}
                                                                    style={{ minWidth: 80 }}
                                                                    onClick={() => handleVerifyy(i)}
                                                                    disabled={verifiedRows.includes(i) || rejectedRows.includes(i)}
                                                                >
                                                                    {verifiedRows.includes(i) ? "Verified" : "Verify"}
                                                                </button>
                                                                <button
                                                                    className={`btn btn-sm ${rejectedRows.includes(i) ? "btn-danger" : "btn-secondary"}`}
                                                                    style={{ minWidth: 80 }}
                                                                    onClick={() => handleReject(i)}
                                                                    disabled={rejectedRows.includes(i) || verifiedRows.includes(i)}
                                                                >
                                                                    {rejectedRows.includes(i) ? "Rejected" : "Reject"}
                                                                </button>
                                                            </td>


                                                        </tr>
                                                    ))}
                                                </tbody>

                                            </table>
                                            {/* <div className="d-flex justify-content-end mt-0 mb-5">
                        <button
                          onClick={handleApprove} // Removed hardcoded ID
                          disabled={isApproved || selectedClient?.status === "APPROVED"}
                          className={`btn fw-bold ${isApproved || selectedClient?.status === "APPROVED"
                              ? "btn-success"
                              : "btn-primary"
                            }`}
                        >
                          {isApproved || selectedClient?.status === "APPROVED"
                            ? "APPROVED"
                            : "APPROVE"}
                        </button>
                      </div> */}

                                            {/* <div className="d-flex justify-content-end mt-0 mb-5">
                        <button
                          onClick={handleApprove}
                          disabled={selectedClient?.approval === "APPROVED"}
                          className={`btn fw-bold ${selectedClient?.approval === "APPROVED" ? "btn-success" : "btn-primary"
                            }`}
                        >
                          {selectedClient?.approval === "APPROVED" ? "APPROVED" : "APPROVE"}
                        </button>
                      </div> */}
                                        </div>



                                        {isApproved && (
                                            <div className="d-flex flex-wrap bg-custom-purple text-white p-3 rounded mt-1 gap-4 mb-5">
                                                <h4>ClientID: {selectedClient?.vendorId || "N/A"}</h4>
                                                <h4>Plan: {selectedClient?.businessPlan || "N/A"}</h4>
                                                <h4>Status: Active</h4>
                                                <h4>Start Date: {selectedClient?.tradeLicenseStartDate || "N/A"}</h4>
                                                <h4>End Date: {selectedClient?.tradeLicenseEndDate || "N/A"}</h4>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ---------- badges &  inline styles ---------- */
const getBadgeStyle = (isActive) => ({
    display: "inline-block",
    minWidth: 70,
    padding: "1px 1px",
    borderRadius: 4,
    fontWeight: "bold",
    color: "#fff",
    textTransform: "uppercase",
    backgroundColor: isActive ? "#28a745" : "#dc3545",
});
const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: 5 };
const thTdStyle = { border: "1px solid #ddd", textAlign: "center" };
const thStyle = { ...thTdStyle, backgroundColor: "#b15cd6", color: "#fff", fontWeight: "bold", maxWidth: "70px" };
const buttonStyle = { backgroundColor: "transparent", border: "none", cursor: "pointer" };
const selectStyle = { height: 35, marginTop: 20, marginRight: 10, borderRadius: 4, fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff" };
const exportButtonStyle = { height: 35, marginTop: 20, borderRadius: 4, border: "none", backgroundColor: "#b15cd6", color: "#fff", fontWeight: "bold" };
const detailThStyle = {
    ...thTdStyle,
    backgroundColor: "#b15cd6",
    color: "#fff",                // white text
    fontWeight: 600,              // slightly heavier than normal bold
    padding: "0.75rem",           // ≈12 px (Bootstrap default)
    verticalAlign: "middle",      // keep the text vertically centered
    border: "1px solid #dee2e6",
    textAlign: "center"
};


export default Logisticspaidclients;
